"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInternalUrl = exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _DownloadLink = _interopRequireDefault(require("../DownloadLink/DownloadLink"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.downloadlinkbox-container {\n  display: flex;\n  flex-direction: column;\n  max-width: 100%;\n  gap: 24px; }\n";
  const fileName = "DownloadLinkBox_DownloadLinkBox";
  const element = document.querySelector("style[data-sass-component='DownloadLinkBox_DownloadLinkBox']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const getInternalUrl = _ref => {
  let {
    link,
    lang,
    isCMS
  } = _ref;
  const section_element = link.section_element ? '#' + link.section_element : '';
  return link.link.original_url?.includes('/' + lang) ? `/${lang}${isCMS ? '/cms' : ''}${link.link.original_url?.replace(`/${lang}`, '') || ''}${section_element}` : `/${lang}${isCMS ? '/cms' : ''}${link.link.original_url?.replace('/cms', '') || ''}${section_element}`;
};
exports.getInternalUrl = getInternalUrl;
const getVariant = link => {
  return link.paragraph_type === 'download_box' ? 'DOWNLOAD' : link.paragraph_type === 'video_box_statische_seite' ? 'VIDEO' : link.link?.url === link.link?.original_url ? 'EXTERNAL' : 'INTERNAL';
};
const getText = link => {
  if (link.paragraph_type === 'download_box') {
    if (!link.download) return '';
    const download = link.download[0];
    if (link.use_name === true) return download.name;
    return download?.description !== '' ? download?.description : download?.uri?.split('/')[download?.uri?.split('/').length - 1 || 0];
  }
  if (link.paragraph_type === 'video_box_statische_seite') {
    return link.video_url?.length > 0 ? link.video_url[0][0].title : '';
  }
  return link.link?.title;
};
const getConsultationText = link => {
  if (!link.download) return '';
  const download = link.download[0];
  const counter = download.counter || 0;
  return getText(link) + ` (${counter})`;
};
const DownloadLinkBox = _ref2 => {
  let {
    items,
    title,
    lang,
    isCMS = true,
    isConsultation,
    openInCurrentTab = false
  } = _ref2;
  const links = items?.map(link => {
    const isCMSPage = link.paragraph_type == 'no_cms_link' ? false : isCMS;
    const variant = getVariant(link);
    const href = link.link?.url;
    const src = variant === 'VIDEO' ? link.video_url[0][0]?.url : '';
    const to = variant === 'DOWNLOAD' ? link.download ? link.download[0]?.get_endpoint : '' : variant === 'INTERNAL' ? getInternalUrl({
      link,
      lang,
      isCMS: isCMSPage
    }) : undefined;
    const text = isConsultation ? getConsultationText(link) : getText(link);
    const start_second = variant === 'VIDEO' && link.video_url[0][0]?.start_second;
    const stop_second = variant === 'VIDEO' && link.video_url[0][0]?.stop_second;
    return {
      variant,
      text,
      href,
      to,
      src,
      start_second,
      stop_second,
      usePdfIcon: link.use_pdf_icon === true || false
    };
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "downloadlinkbox"
  }, title && /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-07 sia-margin-01-bottom"
  }, title), /*#__PURE__*/_react.default.createElement("div", {
    className: "downloadlinkbox-container sia-padding-03-bottom sia-padding-03-right"
  }, links.map((item, index) => /*#__PURE__*/_react.default.createElement("div", {
    key: index
  }, /*#__PURE__*/_react.default.createElement(_DownloadLink.default, _extends({}, item, {
    openInCurrentTab: openInCurrentTab
  }))))));
};
DownloadLinkBox.propTypes = {
  items: _propTypes.default.array.isRequired
};
DownloadLinkBox.defaultProps = {
  lang: ''
};
var _default = exports.default = DownloadLinkBox;